import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import {actionParams} from "./ActionParams";

class UploadINILA extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showMessage: false, messageText: "", messageTitle: ""
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            let key = {};
            await this.props.dispatch(this.props.dataItem_Send.reset());

            await this.props.dispatch(this.props.dataItem.initialize(key, {
                withParams: false, newItem: true
            }));
        } catch (e) {
            console.error(e);
        }
    }

    onClose = () => {
        if (this.props.onClose) this.props.onClose();
    }

    onSave = (e) => {
        e.preventDefault();

        let key = {ReqTypeId: this.props.documentType.ReqTypeId};
        return confirm(i18next.t(this.props.documentType.CommitMessage))
            .then(() => this.props.dispatch(this.props.dataItem_Send.execute(key)))
            .then(() => {
                if (!this.props.dataItem_Send.isError) this.setState({
                    messageText: i18next.t((this.props.dataItem_Send.isError ? this.props.dataItem_Send.ErrorMessage : this.props.documentType.SuccessMessage)),
                    messageTitle: this.props.dataItem_Send.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
                    showMessage: true
                });
            })
            .catch(() => {
            });
    }

    onCancel = (e) => {
        e.preventDefault();

        if (this.props.onClose) this.props.onClose();
    }

    onMessageClose = () => {
        if (this.props.onClose) this.props.onClose()
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular -goahead ml1ex" onClick={this.onSave}>{i18next.t('Send')}
                </button>
                <button className="btn btn-regular ml1ex" onClick={this.onCancel}>{i18next.t('Close')}
                </button>
            </div>
        </div>)
    }

    renderParameter = (handler, parameter) => {
        const fn = parameter.Name;
        return (<div key={parameter.Name} className="row">
            <div className="col-md-6 field-title text-left">{handler.lbl(fn)}</div>
            <div className="col-md-6">{handler.ed(fn)}</div>
        </div>)
    }

    renderGroup = (handler, group) => {
        const content = <>
            {group.Group && group.Group.map((group) => this.renderGroup(handler, group))}
            {group.Parameter && group.Parameter.map((parameter) => parameter.ShowInForm && this.renderParameter(handler, parameter))}
        </>
        if (group.Title) return (
            <PlaceholderWrapper placeholderId={group.Name} key={group.Name} style={group.Style} canCollapse={false}
                                showSplitterLine={true}
                                title={group.Title}>
                {content}
            </PlaceholderWrapper>)
        else return (
            <div style={group.Style} key={group.Name} className="inila_groupContainer">
                {content}
            </div>)
    }

    renderParam = (handler) => {
        const actionParamInfo = actionParams.find(action => action.Id === this.props.documentType.ActionId);
        if (actionParamInfo) return (actionParamInfo.Group && actionParamInfo.Group.map((group) => this.renderGroup(handler, group)))
        else {
            return (<div className="row">
                <div className="col-md-12">
                    {handler.fs.map((fi) => {
                        const fn = fi.Name;
                        return (<React.Fragment key={fn}>
                            <div className="row">
                                <div className="col-md-6 field-title text-left">
                                    {handler.lbl(fn)}
                                </div>
                                <div className="col-md-6">
                                    {handler.ed(fn)}
                                </div>
                            </div>
                            <hr/>
                        </React.Fragment>)
                    })}
                </div>
            </div>)
        }
    }

    render() {
        if (!this.props.documentType) return null;
        return (<PopupWrapper popupVisible={true} title={i18next.t(this.props.documentType.Title)} onClose={this.onClose}
                              showInstruction={false} instructionId="11"
                              renderButtons={this.renderButtons} minHeightBody='200px'>
                <MessageBox visible={this.state.showMessage}
                            title={this.state.messageTitle}
                            messageText={this.state.messageText}
                            onClose={this.onMessageClose}/>
                <PlaceholderWrapper placeholderId={this.props.documentType.ActionId} canCollapse={false}
                                    showSplitterLine={false}
                                    title={`${i18next.t(this.props.documentType.Title)} - ${i18next.t("Old_Variant")}`} showHeaderTitle={false}>
                    <ComplexParam dataItem={this.props.dataItem} readOnly={true}
                                  showApplyButton={false} showSearchBar={false}
                                  rootPath="/"
                                  renderParams={this.renderParam}
                    />
                </PlaceholderWrapper>
            </PopupWrapper>)
    }
}

UploadINILA.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    documentType: PropTypes.object.isRequired,
    dataItem: PropTypes.object,
    dataItem_Send: PropTypes.object
}

UploadINILA.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.privateDocumentsState.PensInsurReq_GetPersDataPO,
        dataItem_Send: state.privateDocumentsState.PensInsurReq_CreateRegDubPO
    }
}

export default connect(mapStateToProps)(UploadINILA)